<template>
  <div>
    <span
      v-if="!validation.required"
      class="md-error"
    >{{ messages.required }}</span>
    <span
      v-else-if="!validation.minLength"
      class="md-error"
    >{{ messages.minLength }}</span>
    <span
      v-else-if="!validation.hasUppercase"
      class="md-error"
    >{{ messages.hasUppercase }}</span>
    <span
      v-else-if="!validation.hasLowercase"
      class="md-error"
    >{{ messages.hasLowercase }}</span>
    <span
      v-else-if="!validation.hasNumber"
      class="md-error"
    >{{ messages.hasNumber }}</span>
    <span
      v-else-if="!validation.hasSpecialChar"
      class="md-error"
    >{{ messages.hasSpecialChar }}</span>
  </div>
</template>

<script>
import { PASSWORD_MESSAGES } from "../../const/validator/password";

export default {
  name: "PasswordErrorMessages",
  props: {
    validation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      messages: PASSWORD_MESSAGES,
    };
  },
};
</script>
